import { v4 as uuidv4 } from 'uuid';
import {Button, Col, Drawer, Form, Input, Row, Space, Table} from 'antd';
import React, { useEffect, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { ApiContentService } from '../../../../../shared/api/content/content.service';
import { ContentSectionValuesRow } from './ContentSectionValuesRow/ContentSectionValuesRow';
import { countText, SectionToolbar, useSectionSearch } from '../../components/SectionToolbar/SectionToolbar';
import { useCanEdit } from '../../../sectionAccess';

const valuesOf = (row) => (Array.isArray(row.value) ? row.value.map((item) => item.value) : []);

export const ContentSection = (props) => {
  const canEdit = useCanEdit();
  const [isModalVisible, setModalVisible] = useState(false)
  const [editableContentId, setEditableContentId] = useState(null)
  const [tableData, setTableData] = useState([]);
  const [contentValues, setContentValues] = useState([]);
  const [contentTitle, setContentTitle] = useState('');
  const [search, setSearch, contents] = useSectionSearch(tableData, ['name', valuesOf]);

  const columns = [
    {
      title: 'Справочник',
      dataIndex: 'name',
      width: 240,
    },
    {
      title: 'Значения',
      key: 'values',
      render: (row) => {
        const values = valuesOf(row);
        const shown = values.slice(0, 6).join(', ');
        return (
          <span className="cell-hint">
            {shown || '—'}
            {values.length > 6 ? ` и ещё ${values.length - 6}` : ''}
          </span>
        );
      },
    },
    canEdit && {
      title: 'Действия',
      width: 220,
      render: (row) => (
        <>
          <Space size="small">
            <Button
              onClick={() => {
                setContentValues(row.value);
                setContentTitle(row.name);
                setModalVisible(true)
                setEditableContentId(row.id)
              }}
            >Изменить</Button>
            <Button
              danger
              onClick={() => {
                let isAgree = window.confirm(`Вы уверены что хотите удалить контент ${row.name}?`)
                if (isAgree) {
                  ApiContentService.deleteContent(row.id).then(() => fetchContent())
                }
              }}
            >
              Удалить
            </Button>
          </Space>
        </>
      ),
    },
  ].filter(Boolean);

  const submitNewContent = async () => {
    if (contentTitle.trim() && contentValues.length) {
      let isEmptyValueExist = false;

      contentValues.forEach((currentValue) => {
        if (currentValue.value.trim() === '') {
          isEmptyValueExist = true;
        }
      });

      if (isEmptyValueExist) return alert('Введите все значения или удалите лишние поля ввода')

      const response = editableContentId
        ? ApiContentService.updateContent(contentTitle, contentValues, editableContentId)
        : ApiContentService.createContent(contentTitle, contentValues);

      response
        .then(() => {
          fetchContent()
          setModalVisible(false)
        })
        .catch(() => alert('Возникла ошибка'))
    }
  };

 /* const updateContent = async () => {
    if (newContentInputValue.trim()) {
      ApiContentService.changeContent(state.contentIdWhichWillBeUpdated, newContentInputValue);

      setTimeout(() => {
        window.location.reload();
      }, 300);
    }
  };*/

  const fetchContent = () => {
    ApiContentService.fetchContents().then((response) => {
      const contents = response.data;
      setTableData(contents);
    });
  }


  useEffect(() => {
   fetchContent()
  }, []);

  return (
    <div className="content-section">
      <Table
        title={() => (
          <SectionToolbar
            search={search}
            onSearch={setSearch}
            placeholder="Название справочника или значение"
            count={countText(tableData.length, contents.length, search)}
          >
            {canEdit && (
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setContentTitle('');
                  setContentValues([]);
                  setEditableContentId(null)
                  setModalVisible(true)
                }}
              >
                Создать справочник
              </Button>
            )}
          </SectionToolbar>
        )}
        columns={columns}
        dataSource={contents}
        rowKey="id"
        locale={{ emptyText: 'Ничего не нашлось' }}
      />

      <Drawer
        title={`${editableContentId ? "Изменить" : "Создать"} справочник`}
        width={720}
        onClose={() => setModalVisible(false)}
        visible={isModalVisible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button onClick={() => setModalVisible(false)} style={{ marginRight: 8 }}>
              Отменить
            </Button>
            <Button onClick={submitNewContent} type="primary">
              {editableContentId ? "Изменить" : "Создать"}
            </Button>
          </div>
        }
      >
        <Form layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={24}>
              <Input
                onChange={(e) => setContentTitle(e.target.value)}
                placeholder="Введите название поля контента"
                value={contentTitle}
                style={{ marginBottom: 10 }}
              />
            </Col>
          </Row>
          {contentValues.map((contentValue, index) => {
            return (
              <ContentSectionValuesRow
                key={contentValue.id}
                inputValue={contentValue.value}
                onDelete={() => {
                  setContentValues((prev) =>
                    prev.filter((currentValue) => currentValue.id !== contentValue.id)
                  );
                }}
                onInputChange={(event) => {
                  const newContentValues = [...contentValues];

                  newContentValues[index].value = event.currentTarget.value;

                  setContentValues(newContentValues);
                }}
              />
            );
          })}
          <br />
          <Button
            style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
            onClick={() => setContentValues((prev) => [...prev, { id: uuidv4(), value: '' }])}
          >
            <PlusOutlined />
          </Button>
        </Form>
      </Drawer>
    </div>
  );
};
